import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { env } from '../../../app.constant';
import { SessionService } from '../../../@core/mock/system/session.service';
import { UserDetailsService } from '../../../@core/utils/system/user-details.service';
import { Auth } from '../../../@core/data/system/auth';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private userDetails: UserDetailsService = inject(UserDetailsService);

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  private menu = [
    { title: 'Manage Fund Source', link: '/pages/manage/fund-source', data: [1, 9] },
    { title: 'Manage Budget Account', link: '/pages/manage/account_budget', data: [1, 9] },
    { title: 'Settings', link: '/pages/settings', data: [1, 2, 8, 9] },
    { title: 'Log out', link: '/public/logout', data: [1, 2, 8, 9, 10, 11] },
    { title: 'Auxiliary System', link: '/public/logout', data: [12] }
  ];

  userMenu = [];

  public campuses = env.campuses;
  public currentCampus = null;
  public userType = 0;

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private sessionService: SessionService,
    private router: Router,
    private cookie: CookieService,
    private authService: Auth) {

    this.userDetails.getDetails().subscribe((session: any) => {
      if (session) {
        console.log(`header.component->session`, session);
        // if (Number(session.code) === 1) {
        this.userType = Number(session.wmt_id);
        this.currentCampus = Number(session.campus_branch_code);
        this.sessionService.setCampusSession(this.currentCampus);

        this.sessionService.getCampusSession().subscribe((campus: number) => {
          if (campus) {
            this.currentCampus = campus;
          }
        });

        this.user = {
          // name: session.message.mem_user_name,
          name: session.mem_fullname,
        };
        this.userMenu = this.menu.filter((item: any) => { return item.data.includes(this.userType) ? true : false; });
        // }
      }
    });
  }

  ngOnInit() {
    console.log(`headerComponent->ngOnInit()`);
    this.currentTheme = this.themeService.currentTheme;

    // this.userService.getUsers()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((users: any) => this.user = users.admin);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    // let interval = setInterval(() => {
    //   this.sessionService.getExpirationTime().subscribe((token_expiration: any) => {
    //     if (token_expiration) {
    //       let now = new Date();
    //       let hours = (((Number(token_expiration) - now.getTime()) / 1000) / 60) / 60;
    //       // console.log(`headerComponent->ngOnInit()->hours ${hours}`);
    //       if (hours < env.token_renew_expire_at) {
    //         this.authService.getNewSession().subscribe((response: any) => {
    //           if (Number(response.code) === 1) {
    //             let new_expiration = new Date();
    //             this.sessionService.setExiprationTime(new_expiration.getTime() + (((env.token_hours_expiration * 60) * 60) * 1000));
    //             this.sessionService.setUserSession(response.message);
    //           }
    //         });
    //       }
    //       return;
    //     }
    //     clearInterval(interval);
    //   });
    // }, 5000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeCampus() {
    this.sessionService.setCampusSession(this.currentCampus);
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  navigateAuxiliary() {
    this.authService.logout().subscribe((response: any) => {
      if (Number(response.code) === 1) {
        this.cookie.delete('AuthToken');
        this.cookie.delete('expiration');
        this.cookie.delete('wmt_id');
        this.sessionService.deleteUserSession().subscribe((status: boolean) => {
          if (status) {
            console.log("session delete");
            console.log(`logout->response`, response);
            window.location.href = env.igp.auxiliary_url;
          }
        });
      }
    }, (error: any) => {
      this.cookie.delete('AuthToken');
      this.cookie.delete('expiration');
    });
  }

  getCampusName(id: number) {
    let selectedCampus = this.campuses.filter((campus: any) => Number(campus.value) === id);
    return (selectedCampus.length > 0) ? selectedCampus[0].text : "N/A";
  }
}
